import * as axiosHelper from "../api_helper";
import qs from "qs";

export const getPammTransferAccountsAPI = () => axiosHelper.get("/wallet/transfer/pamm-accounts");

export const getAccountDetailsAPI = async (_id) => {
  try {
    return await axiosHelper.get(`/accounts/${_id}`);
  } catch (error) {
    throw new Error("Error while fetching accounts.");
  }
};

export const getAccountsAPI = async (params) => {
  try {
    return await axiosHelper.get(`/accounts?${qs.stringify(params)}`);
  } catch (error) {
    throw new Error("Error while fetching accounts.");
  }
};

export const getAllAccountsAPI = async () => {
  const accounts = new Map();
  let page = 1;
  let hasMore = true;
  const limit = 100;
  while (hasMore) {
    const response = await getAccountsAPI({
      page,
      limit
    });
    const result = response?.result;
    if (!response?.status || !Array.isArray(result?.docs)) {
      throw new Error(response?.message || "Unable to load trading accounts");
    }
    result.docs.forEach((account) => accounts.set(account._id, account));
    hasMore = !(result.hasNextPage === false || (Number(result.totalPages) > 0 && page >= Number(result.totalPages))
      || (result.hasNextPage !== true && result.docs.length < limit));
    if (hasMore && result.docs.length === 0) throw new Error("Incomplete trading account pagination");
    page++;
  }
  return Array.from(accounts.values());
};

export const createAccountAPI = async (params) => {
  try {
    return await axiosHelper.post("/accounts", params);
  } catch (error) {
    throw new Error("Error while creating new account.");
  }
};

export const getAccountTypesAPI = async (params) => {
  try {
    return await axiosHelper.get(
      `/accounts/account-types?${qs.stringify(params)}`
    );
  } catch (error) {
    throw new Error("Error while creating new account.");
  }
};

export const getAccountAPI = async (params) => {
  try {
    return await axiosHelper.get(
      `/accounts/account-types?${qs.stringify(params)}`
    );
  } catch (error) {
    throw new Error("Error while creating new account.");
  }
};

export const updateLeverageAPI = async ({ _id, body }) => {
  try {
    return await axiosHelper.post(`/accounts/${_id}/change-leverage`, body);
  } catch (error) {
    throw new Error("Error while updating leverage.");
  }
};

export const updatePasswordAPI = async ({ _id, body }) => {
  try {
    return await axiosHelper.post(`/accounts/${_id}/change-password`, body);
  } catch (error) {
    throw new Error("Error while updating password.");
  }
};

export const getOpenPositionsAPI = async ({ _id, page, limit }) => {
  try {
    return await axiosHelper.get(
      `/accounts/${_id}/open-positions?${qs.stringify({
        page,
        limit,
      })}`
    );
  } catch (error) {
    throw new Error("Error while fetching open positions.");
  }
};

export const getClosePositionsAPI = async ({ _id }) => {
  try {
    return await axiosHelper.get(`/accounts/${_id}/close-positions`);
  } catch (error) {
    throw new Error("Error while fetching close positions.");
  }
};

export const getProfitGraphAPI5 = async ({ _id }) => {
  try {
    // cache this
    const resp = await axiosHelper.get(`/accounts/${_id}/profit-graph`);
    return resp.result;
  } catch (error) {
    throw new Error("Error while fetching profit graph.");
  }
};

export const getTransfersAPI = async (params) => {
  try {
    return await axiosHelper.get(`fxtransactions/all?${qs.stringify(params)}`);
  } catch (error) {
    throw new Error("Error while fetching latest transactions.");
  }
};

export const createInternalTransferAPI = async (body) => {
  try {
    return await axiosHelper.post("fxtransactions/internalTransfers", body);
  } catch (error) {
    throw new Error("Error while making an internal transfer");
  }
};

export const getTradingAccountByLogin = async ({ payload })=>{
  const result = await axiosHelper.get(`/accounts?${qs.stringify(payload)}`);
  if (!result.status) {
    throw new Error(result.message);
  }

  return result;
};
export const searchAccountAPI = async (params) => {
  try {
    return await axiosHelper.post(`/accounts/mam-search?${qs.stringify(params)}`);
  } catch (error) {
    throw new Error("Error while searching account.");
  }
};

export const getInvestorAccountsAPI = async (params) => {
  try {
    return await axiosHelper.get(`/accounts/investor-accounts?${qs.stringify(params)}`);
  } catch (error) {
    throw new Error("Error while fetching investor accounts.");
  }
};

export const getAvailableInvestorAccountsAPI = async (params) => {
  try {
    return await axiosHelper.get(`/accounts/investor/available?${qs.stringify(params)}`);
  } catch (error) {
    throw new Error("Error while fetching available investor accounts.");
  }
};

export const getProfitGraphAPI = async (params) => {
  try {
    return await axiosHelper.get(`/accounts/profit-graph?${qs.stringify(params)}`);
  } catch (error) {
    throw new Error("Error while fetching profit graph.");
  }
};
